import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChartVerticalBars = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.75 5C12.75 4.0335 13.5335 3.25 14.5 3.25H18.5C19.4665 3.25 20.25 4.0335 20.25 5V17.25C20.25 18.2165 19.4665 19 18.5 19H14.5C13.5335 19 12.75 18.2165 12.75 17.25V5ZM14.5 4.75C14.3619 4.75 14.25 4.86193 14.25 5V17.25C14.25 17.3881 14.3619 17.5 14.5 17.5H18.5C18.6381 17.5 18.75 17.3881 18.75 17.25V5C18.75 4.86193 18.6381 4.75 18.5 4.75H14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.75 12C3.75 11.0335 4.5335 10.25 5.5 10.25H9.5C10.4665 10.25 11.25 11.0335 11.25 12V17.25C11.25 18.2165 10.4665 19 9.5 19H5.5C4.5335 19 3.75 18.2165 3.75 17.25V12ZM5.5 11.75C5.36193 11.75 5.25 11.8619 5.25 12V17.25C5.25 17.3881 5.36193 17.5 5.5 17.5H9.5C9.63807 17.5 9.75 17.3881 9.75 17.25V12C9.75 11.8619 9.63807 11.75 9.5 11.75H5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 20.25C2.58579 20.25 2.25 20.5858 2.25 21C2.25 21.4142 2.58579 21.75 3 21.75H21C21.4142 21.75 21.75 21.4142 21.75 21C21.75 20.5858 21.4142 20.25 21 20.25H3Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconChartVerticalBars as ReactComponent };
